module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "article"
  }, [_c('p', {
    staticClass: "fwbd tc mt20"
  }, [_vm._v("借款合同")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin mt20"
  }, [_vm._v("特别提醒:上海华瑞银行股份有限公司(以下简称“华瑞银行”，即贷款人) 将为您(亦称“ 借款人”)提供本合同项下的人民币贷款服务。具体借款信息以本合同项下电子借据所载信息为准 。电子借据是本合同组成部分之一，具有同等的法律效力。您在此确认并同意您与电子借据上所载 的贷款人形成本合同项下的借款关系，受本合同约束。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("为了保障您的合法权益，您应当阅读并遵守“借款合同”(以下简称“本合同”)，请您务必审\n慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，限制、免责条款可能以加黑加粗\n的形式提示您注意。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("除非您已阅读并接受本合同所有条款，否则您无权使用贷款服务。您的登录、使用等行为即视为 您已阅读并同意接受本合同的约束,本合同即时生效。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("本合同由您和贷款人共同签署。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("第一条术语定义")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1.1 贷款人线上服务平台:指您向贷款人提出贷款审批、查看额度、申请借款等操作的在线或移 动平台。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("1.2 授信额度有效期:指在授信额度内，您可向贷款人申请贷款的期限。本合同初始授信额度有 效期为自本合同生效之日起12个月，授信额度有效期届满前，若本合同双方均无异议，可从到期之 日起自动展期，展期次数不限。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1.3 可使用授信额度:是指当期您可以使用的额度。可使用额度=授信额度-额度项下您已经支取 且尚未结清的单笔借款尚未还清的本金之和")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1.4 提款申请:您应向贷款人发出提款的支付申请，逐笔向贷款人申请提取贷款资金。贷款人有 权根据您的风险状况或经营情况调整您使用贷款的提款(支付)限额(包括但不限于当日可发放总 规模限额、单笔限额、每日限额和每月限额)及提款笔数。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1.5 收款账户:指您申请、使用本贷款服务，提供给贷款人发放贷款的银行账户。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1.6 还款账户:指您申请、使用本贷款服务时，在借款过程中确定的我行账户以及发起提前还款 时您在我行绑定的本人他行账户。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("1.7 代扣还款:指为偿还本合同项下应付款项的目的，您无条件不可撤销地同意并授权贷款人代 您持续向还款账户开户行、有权的第三方支付清算机构，包括但不限于银联等卡组织、人行清算组 织机构等机构(以下统称“第三方支付机构组织”)发送代扣指令，直接将您还款账户的款项划扣 至指定还款账户，用于偿还您在贷款人处全部债务直至清偿完毕，且贷款人有权将同一还款日的多 笔贷款应还款额合为一笔或分成特定金额，分笔、分批发出交易委托指令。您承诺前述交易委托指 令视同您本人做出。代扣时间、金额等指令以贷款人通知为准。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("1.8 场景贷:全称“华瑞银行·众安保险场景贷业务”，指华瑞银行与众安合作项下的多种消费 类贷款信用保险服务产品总称，具体产品清单详细见附件。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("第二条合同的形式")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("您与华瑞银行一致同意本合同以数据电文形式订立并认同其效力。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("第三条申请及信息授权")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("3.1 您须亲自通过贷款人线上服务平台向贷款人提出借款申请，同时务必通过该服务平台交易密码 等方式校验验证您的身份。凡校验通过的，方视为您本人申请。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3.2 您应妥善保管您的手机设备(含手机号码)、贷款人线上服务平台账号及密码，与贷款人线 上服务平台绑定的手机号码、手机验证码等信息，您应确保不向任何人泄露您以上信息。"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("对于因账 号、密码泄露所致的损失，由您自行承担。如您发现有他人冒用或盗用您的账号及密码申请本贷款 业务的，您应立即以有效方式通知贷款人，要求贷款人暂停本服务。同时，您理解贷款人对您的请 求采取行动需要合理期限，在此之前，贷款人对已执行的指令及(或)所导致您的损失不承担任何 责任。")])]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("3.3 您保证向贷款人提供的所有申请信息是真实、完整、准确、合法、有效的，并授权华瑞银行 向有关机构或单位(包括但不限于中国人民银行个人信用信息基础数据库、合法的征信机构、公安 机关、公积金、社保、税务、民政等)查询或确认与您借款申请相关信息。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3.4 华瑞银行承诺根据监管要求对客户资料承担保密义务,不得将收集到的用户相关信息提供给贷 款人以外的无关的第三方。"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("您同意，华瑞银行可以向中国人民银行金融信用信息基础数据库、其他 依法设立的征信机构、查询您使用本服务所必要的个人身份信息及信用信息(包括不良信息)。")])]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("3.5 贷款人有权依据您的资信情况综合自主决定是否受理您的借款申请及核定您的信用额度，且 在核定您的信用额度后，贷款人有权根据掌握的您的信用情况或认定的风险控管因素或其他正当理 由，随时调整您的信用额度(包括但不限于调低、调高或者中止、终止)。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("3.6 贷款人核定的您的信用额度并不构成贷款人对您的授信承诺，信用额度项下具体提款业务， 您应逐笔在授信额度有效期内及可使用授信额度内向贷款人申请提款，贷款人有权根据您的当期信 用及贷款人当期可贷款资金规模自主决定是否向您发放额度项下单笔贷款以及具体贷款金额。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("第四条额度的使用、提款")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4.1 您应保证在安全环境下通过各种媒介使用本信用额度，否则您须对非安全环境下本信用额度 在互联网或其它媒介上使用所导致的风险和损失自行负责。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("4.2 您知悉贷款人通过贷款人线上服务平台校验交易密码对使用本额度的交易进行身份验证，并 同意任何通过密码校验成功产生的交易均为其本人交易，并由您承担相应的交易后果。您应确保妥 善保管并不向任何人泄露交易密码，对于因密码泄露所致的损失，由您自行承担。您电子确认的交 易凭证以及依据交易密码等电子数据信息办理的各类结算交易和信用额度提取、还款交易所产生的 电子信息记录，均视为该项交易的有效凭证。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("4.3 本额度项下单笔贷款金额以经您确认的电子借据所载信息为准。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4.4 本信用额度项下单笔贷款不能用于个人购买住房、进行证券投资"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("或用于股本权益性投资贷款 资金、不得用于期货等投机经营或从事其他违法、违规交易")]), _vm._v("，否则视同违约。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4.5 本额度项下单笔贷款均采用自主支付，贷款人根据您的提款申请将贷款资金直接发放到您的收 款账户上，并由您通过取现、转账、支付等方式自主支付给符合日常消费用途的交易对象。贷款人 有权变更您对本额度的自主支付提款次数及单笔提款金额上限与下限，并且无需另行通知您。您应\n        定期报告或告知贷款人贷款资金支付情况，贷款人有权通过账户分析、凭证查验、现场调查等方式\n        核查贷款支付是否符合约定用途。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4.6 您应保证提供准确的账户信息给贷款人，若您提供的账户信息有误、账户状态不正常、或者 因所提供账户的开户银行汇款转账系统延误、故障或者因人行跨行转账系统延误、故障等原因导致 贷款人发放的贷款未能在电子借据所载的贷款起始日当日支付至您指定的账户的，贷款人不承担责 任，贷款利息、分期手续费、贷款服务费等仍然按电子借据所载的贷款起始日起算。若因上述原因 导致贷款人放款失败的，您需重新申请放款。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("4.7 您不得利用本信用额度进行偷逃税款、逃废债务、套取现金、洗钱及其他违法犯罪活动，若 您在使用本信用额度过程中出现监管机关规定的或贷款人依其主观判断认定的风险特征时，贷款人 有权不经任何形式的事先通知或事先确认而随时中止或终止您对本信用额度的使用，您有义务积极 协助贷款人识别相关风险，并承担因此所产生的损失。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("4.8 若因贷款人线上服务平台或与本合同项下贷款相关的其他网站网络系统原因导致华瑞银行实 际发放给借款人的贷款金额(以下简称“实际发放金额”)与按本合同应发放的贷款金额(以下简 称“应发金额”)不一致，则您和华瑞银行同意按以下规则调整:")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("若实际发放金额<应发金额，则借款人的贷款金额以实际发放金额为准; 若应发金额<实际发放 金额，则借款人的贷款金额以应发金额为准，华瑞银行有权要求借款人返还相当于实际发放金额与 应发金额之差额的资金，借款人在接到华瑞银行通知后5个工作日内应无条件将前述差额资金返还 给华瑞银行，华瑞银行对在上述5个工作日内返还的该等差额资金不计利息")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 fwbd"
  }, [_vm._v("第五条 利率及期限")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("5.1 本额度项下贷款年化固定利率不受人民银行基准利率调整的影响。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("5.2 您使用本额度项下贷款时，贷款人将自贷款发放起计收利息，单笔贷款利率以您确认的电子\n        借据为准。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("5.3 贷款人有权修改或新增利息收取标准，标准修改或新增后将在贷款人提供的电子服务平台进\n        行公告，若您不同意修改或新增费用项目或标准，可停止申请新的贷款，您之前申请的贷款利息标\n        准不受影响。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("5.4 单笔贷款期限自贷款发放起开始计算，发放日期、到期日期、还款日以您确认的电子电子借 据信息为准。由于每笔贷款的发放日期不同，借款期限并非一个整自然月。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("第六条 对账和还款")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6.1 您应主动查询您账户信用额度的交易明细以确认交易内容。"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("贷款人所保存的本信用额度项下 的交易记录，均为本额度使用的真实凭据，对您具有约束力。您不得以未收到对账单或未看到交易 明细为由否认额度资金使用行为或交易款项。")])]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6.2 本额度项下单笔贷款采用等额本息方式还款，具体计算方式为:")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("等额本息:每期还款金额=( 贷款本金×贷款月利率×借款期限+贷款本金)/借款期限。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("贷款月利率=贷款年利率/12")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6.3 您应在每期贷款的还款日前归还当期应还款金额，首期还款日期以您提款过程中经您电子确 认的电子借据为准，还款日的规则如下:")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(一) 单一客户额度项下所有单笔贷款每月还款日为该笔 贷款的借款日;")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(二) 若该笔贷款的还款月份无此借款日，则该笔贷款的还款日为该月最后一日。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6.4 您已充分理解并确认为实现您的还款日便利而可能出现的单笔贷款单期实际计息不足三十天 的情况。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6.5 还款方式分为主动还款或自动还款:")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1) 主动还款:您可主动向贷款人偿还借款本息及相 关费用。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(2) 自动还款(委托代扣服务):您需在约定的还款日前一天将应还款项足额存入您的 还款账户，您不可撤销地授权贷款人从您的还款账户中扣收本合同项下的贷款本息、贷款人对您的 代垫费用及其他相关费用。您承诺前述交易委托指令视同您本人作出。代扣时间、金额等指令以贷 款人通知为准，代扣的全部责任由您与贷款人承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(3) 您承诺在使用委托代扣或主动还款服务 时，您的承诺和指令均遵守国家法律、法规和本协议目的且不侵犯、贷款人及其他第三方的合法权 益，否则，相关机构有权立即单方面终止提供本服务，并不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(4) 您在此确认和授 权，当您的还款账户余额不足时，贷款人有权降低代扣额度以及多次分笔通过还款账户开户行或第 三方支付机构组织发出代扣指令。(5)若因各种原因(包括但不限于还款账户余额不足)造成自 动扣款失败，逾期未清偿任何款项将影响您的征信记录，由此产生的逾期后果和其他不利后果由您 自行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("6.6 还款顺序:贷款人扣收款项按照先前期、后当期和先罚息、利息、后本金的顺序进行，但贷 款人有权根据您的信用状况和贷款人的风险政策单方面变更前述扣款顺序，而无需另行通知您。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6.7 在您未清偿所有贷款本金、利息及费用前，您不得变更、注销您的还款账户，特殊情况除 外。如遇特殊情况，经贷款人审批后可变更您的还款账户，但贷款功能会受到限制。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("6.8 您有权申请提前结清，但在借款当日不能提前结清。当有多笔未结清贷款时，贷款人有权 限定您提前结清的电子借据顺序及金额下限，具体以贷款人受理您的提前还款申请后的终审结果为 准。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6.9在不对已办理的本合同项下业务中的您的权益产生重大不利影响的前提下，贷款人保留对 上述计息、计费与还款规则进行调整的权利。该等调整一经贷款人做出并以贷款人官方网站公告、 或者客户服务热线提示等方式公布，或者以电话或者短信方式通知您后，即于贷款人确定的生效日 期起正式生效。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20 "
  }, [_vm._v("第七条 合同变更、解除、权利义务的转让")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("7.1 合同变更与解除")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1) 贷款人有权随时单方面修改本合同中与您相关的权利义务，一旦合同\n        条款变更，贷款人将在本贷款人线上服务平台进行公示，除法律法规或监管规定另有强制性规定外 ，经修订的内容一经公示，立即生效。若您不同意修改本合同，则应当自该等告示之日起立即停止 使用本服务并全额还清本合同项下的应付款项;否则，视为您同意并接受修改后的合同。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(2) 本 合同生效后，除本合同另有约定外，您不得要求单方擅自变更或解除本合同。贷款人有权基于自身 经营考虑，随时宣布中断、终止本合同或其任何部分，并要求您在指定期限内偿还本合同项下应付 款项。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("7.2 合同权利义务的转让")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("未经贷款人书面同意，您不得将本合同项下的权利和义务转让给任何第 三方。贷款人有权将其在本合同项下的权利和义务全部或部分转让给第三方，且转让行为无须征得 您的同意，贷款人将通知您该等转让行为。")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 fwbd"
  }, [_vm._v("第八条 贷款人和您(借款人)的权利和义务")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 fwbd"
  }, [_vm._v("8.1 您(借款人)的主要权利")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1) 有权依本合同的约定获得贷款。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(2) 有权向贷款人了解、咨 询、知悉个人信用贷款业务有关事项。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("8.2 您(借款人)的主要义务")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1) 按本合同的约定履行还款义务。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(2) 贷款用途符合国家法律法 规及有关政策规定，并按合同约定的用途使用贷款。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(3) 配合贷款人对其资信状况进行调查。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("8.3 贷款人的主要权利")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1) 有权对您提供的资料、文件的合法性、真实性进行调查。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(2) 有权 检查贷款的使用情况。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("8.4 贷款人的主要义务")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1)按本合同的约定发放贷款。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("第九条 违约条款")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("9.1 下列任一事件均构成本条款所称违约事件:")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1) 您未按双方约定的用途使用贷款或将资金用 于禁止领域;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(2) 您拖欠本金或利息、费用;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(3) 您在履行与贷款人或其他金融机构签订的其他 合同时有违约行为;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(4) 您未履行本合同下任何义务的行为;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(5) 您向贷款人提供虚假的信息; ")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(6) 您转移资产以逃避债务的;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(7) 您发生严重影响偿债能力的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(8) 您明确表示或以自 己的行为表示将不会履行本合同项下的义务。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("9.2 有违约事件发生时，贷款人有权采取下列措施:")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1) 要求您限期纠正违约行为;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(2) 停止 发放您尚未使用的贷款;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(3) 要求您提前归还已发放的全部贷款本金并结清利息;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(4) 根据贷款 风险状况调整贷款金额、期限与利率;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(5) 宣布本合同项下您未偿还的贷款提前到期，委托还款 账户开户行或第三方支付机构组织从您的还款账户中扣除相应金额以收回相关贷款本金、利息、费 用、罚息以及所有其他应付费用，或以合法手段追偿您应付款项;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(6) 从您在贷款人任何营业机 构开立的账户中扣收您应偿付的贷款本金、利息、费用、罚息以及所有其他应付费用;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(7) 对您 的违约行为，可以公开披露;")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(8) 采取法律、法规规定的其他救济措施。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("9.3 您任何一期未及时足额归还借款本息即视为逾期，从逾期之日起对逾期贷款金额按本合同项 下电子借据中约定的利率加收50%计收罚息，直至清偿逾期本息为止。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("9.4 在您发生拖欠还款的情况时，贷款人有权在进行催收和追索债务等工作时，将您的身份信息、 联络信息及您拖欠本合同项下债务的相关信息提供给第三方(包括律师事务所和催收机构);且贷 款人将督促该等第三方妥善保管、保密和谨慎使用前述信息，不得用作委托催收和追索债务以外的 其他用途，以及不得以任何违法的方式进行催收和追索债务。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("9.5 贷款人因向您催收欠款及实现债权而产生的一切费用(包括但不限于公证费、诉讼费、律师 费、差旅费)，均由您承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("第十条免责条款")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("10.1 贷款发放前，如因国家有关部门颁布的法律、法规、规章、规定、指引、通知(包括口头通 知)、政策及其他规范性文件导致贷款人不能发放本合同项下贷款的，贷款人有权停止发放贷款或 解除本合同，不视为贷款人违约，贷款人不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("10.2 贷款人软(硬)件系统出现下列任一状况而无法正常运作，致使无法向您提供本服务，贷款 人均不承担任何违约或赔偿责任，该状况包括但不限于:")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(1) 在本服务网站维护期间。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(2) 电 信设备出现故障不能进行数据传输的。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(3) 因台风、地震、海啸、洪水、停电、战争、恐怖袭击\n        等不可抗力之因素，造成本服务运行系统障碍不能执行业务的。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(4) 由于黑客攻击、电信部门、 还款账户开户行和其他第三方支付机构组织有信息技术依赖的相关部门、企事业单位技术调整或故 障、网站升级等原因而造成的服务中断或者延迟。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("(5)其他非贷款人原因导致的故障")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 fwbd"
  }, [_vm._v("第十一条 承诺与保证")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("除在本合同其他条款中已做出的承诺与保证之外，您同意在此还向贷款人作出如下承诺与保证: ")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(1) 您拥有完全权利能力和行为能力签署及履行本合同，签署本合同是您的真实意思表示。本合 同构成对您具有约束力的协议，贷款人可以根据合同条款要求您履约或对您执行。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(2) 您具有有 效的身份证明，信用良好，有能力按期偿还贷款相关款项。您在本合同下的债务以其个人财产和夫 妻共同财产承担清偿责任，且您已获得配偶(如有)的同意。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(3) 您订立和履行本合同，并不违 反任何对您有约束力的法律、法规、规章、行政命令或生效的司法裁判/仲裁裁决，不违反任何对 您有约束力的合同、协议或承诺，不侵犯任何第三方的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(4) 贷款期内，您如发生经济 情况恶化包括但不限于失业、单位破产或个人财产遭受重大损失、个人身体情况发生重大不利变化 等可能影响您履行本合同能力的事项，应在发生或可能发生之日起7个工作日内通知贷款人，贷款 人有权根据具体情况决定是否提前收回部分或全部贷款。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("(5) 接受贷款人对本合同项下贷款使用 情况和您的有关财务活动情况进行监督和检查，按照华瑞银行的要求及时提供真实、准确、完整的 资料，并为华瑞银行的前述监督和检查提供工作方便")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("第十二条附则")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("12.1 贷款人线上服务平台所公布的服务收费标准、电子借据及电子补充协议、附件是本协议不 可分割的部分，与本协议具有同等法律效力。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("12.2 您在向贷款人提供的资料及信息(包括但不限于 姓名、国籍、住所地、工作单位、联系电话、身份证件或者身份证明文件的号码、有效期等身份信 息)发生变更的，应在信息发生变更之日起7日内通过贷款人提供的线上服务平台更新相关信息; 贷款人就本协议给予其他方的任何通知、要求或其它函件，一经发送到您向贷款人提供的信息中所 示的地址，即视为已送达，因您不及时变更信息而引起的责任及产生的损失，由您自行承担，贷款 人有权因此停止为您发放新的贷款。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr fwbd"
  }, [_vm._v("12.3 管辖及法律适用")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr fwbd"
  }, [_vm._v("(1) 本合同签订地为中华人民共和国上 海市浦东新区。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr fwbd"
  }, [_vm._v("(2) 本合同的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地 区法律(不包括冲突法)。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr fwbd"
  }, [_vm._v("(3) 若您和贷款人之间发生任何纠纷或争议，首先应友好协商解决; 协商不成的，您同意将纠纷或争议提交本合同签订地有管辖权的人民法院管辖，本合同签订地为中 华人民共和国上海市浦东新区。")]), _vm._v(" "), _c('p', {
    staticClass: "txin txdr fwbd"
  }, [_vm._v("(4) 本合同条款无论因何种原因部分无效或不可执行，其余条款 仍有效，对双方具有约束力。")]), _vm._v(" "), _c('p', {
    staticClass: "tc fwbd mt20"
  }, [_vm._v("个人征信授权书")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd"
  }, [_vm._v("重要提示:")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("为了保障您的合法权益，您应当阅读并遵守本授权书，请您务必审慎阅读、充分理解\n        本授权书条款内容，特别是免除或者减轻上海华瑞银行股份有限公司(以下简称为“被授权人”或\n        “贷款人”)责任，或限制您权利的条款，其中免除或者减轻责任条款已经以加粗形式提示您特别\n        关注。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd mt20"
  }, [_vm._v("除非您已阅读并同意本授权书所有条款，否则您无权使用“华瑞银行·众安保险场景贷业务\n        ”(即被授权人与众安在线财产保险股份有限公司合作项下的消费类贷款信用保险服务产品，产品\n        清单详细见附件，以下简称“场景贷”)相关产品服务。您的登录、使用等行为即视为您已阅读并\n        同意接受本授权书条款的约束。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_vm._v("上海华瑞银行股份有限公司:")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("一、本人同意并不可撤销地授权:"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("贷款人按照国家相关规定采集符合法律法规规定的本人个人信息及包括信贷信息在内的信用信息(含\n        本人在贷款人处办理业务时产生的不良信息)，并可以向中国人民银行金融信用信息基础数据库、\n        其他依法设立的征信机构提供以上信息。")])]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("二、本人同意并不可撤销地授权:"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("贷款人可以根据国家有\n        关规定，通过中国人民银行金融信用信息基础数据库、其他依法设立的征信机构、公安部公民身份\n        信息数据库、第三方机构(包括但不限于本人工作单位、社保、公积金、税务、民政、通讯运营商\n        等)查询、打印、保存符合法律法规规定的本人个人信息和包括信贷信息在内的信用信息。")]), _vm._v("用途如下:")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("(一) 审核本人贷款申请;")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("(二) 处理贷后管理事务;")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("(三) 处理本人征信异议;")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("(四) 依法或经有权部门要求;")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("(五) 审核本人向贵行申请或办理其他业务的申请。")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 fwbd"
  }, [_vm._v("授权人声明:")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 fwbd"
  }, [_vm._v("本授权书是本人向上海华瑞银行股份有限公司做出的单方承诺，效力具有独立性，不因场景贷《借款合同》的\n        任何条款无效而失效。")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("以上授权期限为本人作出本授权承诺之日起至本人在贷款人处所有业务终结\n        之日止。"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("本人在贷款人处有借款额度但无借款余额的情况下，本人与贷款人的业务关系仍然存续，\n        贷款人仍有权向中国人民银行金融信用信息基础数据库查询、上报本人的信用信息。")])]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 fwbd"
  }, [_vm._v("若本人与被授权人发生任何纠纷或争议，首先应友好协商解决;协商不成的，本人同意将纠纷或争议提交本授权\n        书签订地(即中国上海市浦东新区)有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律(不包括冲突法)。")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20 fwbd"
  }, [_vm._v("本人已知悉本授权书所有内\n        容(特别是加粗字体内容)的意义以及由此产生的法律效力，自愿作出上述授权，本授权书是本人\n        真实的意思表示，本人同意承担由此带来的一切法律后果。")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("特此授权!")]), _vm._v(" "), _c('p', {
    staticClass: "tc fwbd mt20"
  }, [_vm._v("个人信息使用授权书")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20 txin"
  }, [_vm._v("重要提示:")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20 txin"
  }, [_vm._v("为了保障您的合法权益，您应当阅读并遵守本授权书，请您务必审慎阅读、充分理 解本授权书条款内容，特别是免除或者减轻上海华瑞银行股份有限公司(以下简称为“被授权人” )责任，或限制您权利的条款，其中免除或者减轻责任条款已经以加粗形式提示您注意。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20 txin"
  }, [_vm._v("除非您已阅读并同意本授权书所有条款，否则您无权使用“华瑞银行·众安保险场景贷业务”(即被授权 人与众安在线财产保险股份有限公司合作项下的消费类贷款信用保险服务产品，产品清单详细见附 件，以下简称“场景贷”)相关产品服务。您的登录、使用等行为即视为您已阅读并同意接受本授 权书条款的约束。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_vm._v("上海华瑞银行股份有限公司:")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("本人充分理解并同意，“场景贷”服务是上海华瑞 银行股份有限公司(以下简称“华瑞银行”)与众安在线财产保险股份有限公司合作为本人提供的 贷款信用保险服务产品，现本人主动申请开通此项服务，为客观、准确地评估本人的信用等级和授 信额度，并为本人提供优质地服务，就使用本人的相关必要信息，本人同意并授权如下。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("一、本人 同意并授权，"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("华瑞银行可使用和分析本人在华瑞银行中的相关历史信息、支付数据信息;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("二、本人 同意并授权，"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("为便于华瑞银行给本人发放贷款，华瑞银行可以将本人的姓名、身份证号、联系方式 、银行卡信息及其他相关必要信息传输给第三方机构查询本人相关信息;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("三、本人同意并授权，"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("在 本人逾期还款时，华瑞银行通可将本人的其他联系方式和联系地址等信息传输给华瑞银行合作的催 收机构作催收贷款所用;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("四、本人同意并授权，"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("华瑞银行仅将以上信息作本贷款分析所用，将严格 保护本人的隐私，同时并未违反华瑞银行与本人之间的相关保密义务，且华瑞银行应免予承担任何 违约责任或赔偿责任;")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin fwbd"
  }, [_vm._v("五、本人授权华瑞银行查询的信息、本人享受华瑞银行服务产生的信息，为 便于向本人提供更加优质的服务和产品，本人授权华瑞银行可以将前述信息分享给必要的合作伙伴。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_vm._v("授权人声明:")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin fwbd"
  }, [_vm._v("本授权书是本人向上海华瑞银行股份有限公司做出的单方承诺，效力具有独立性 ，不因场景贷《借款合同》的任何条款无效而失效。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("以上授权期限为本人作出本授权承诺之日起至 本人在贷款人处所有业务终结之日止。"), _c('span', {
    staticClass: "fwbd"
  }, [_vm._v("本人在贷款人处有借款额度但无借款余额的情况下，本人与\n        贷款人的业务关系仍然存续，贷款人仍有权向中国人民银行金融信用信息基础数据库查询、上报本\n        人的信用信息。")])]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin fwbd"
  }, [_vm._v("若本人与被授权人发生任何纠纷或争议，首先应友好协商解决;协商不成的，本人\n        同意将纠纷或争议提交本授权书签订地(即中国上海市浦东新区)有管辖权的人民法院管辖。本授\n        权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律(不包括冲突法)\n        。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin fwbd"
  }, [_vm._v("本人已知悉本授权书所有内容(特别是加粗字体内容)的意义以及由此产生的法律效力，自愿作\n        出上述授权，本授权书是本人真实的意思表示，本人同意承担由此带来的一切法律后果。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("特此授权\n        !")]), _vm._v(" "), _c('p', {
    staticClass: "tc fwbd mt20"
  }, [_vm._v("贷款用途声明及承诺书")]), _vm._v(" "), _c('p', {
    staticClass: "mt20"
  }, [_vm._v("上海华瑞银行:")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 txin"
  }, [_vm._v("本人基于向上海华瑞银行申请的“华瑞银行·众安保险场景贷业务”(即上海华 瑞银行与众安在线财产保险股份有限公司合作项下的消费类贷款信用保险服务产品，产品清单详细 见附件，以下简称“场景贷”)相关产品服务，现声明及承诺如下:")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("1、本人声明向贵行所提供的 所有贷款资料(含用途资料)完全真实、合法。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("2、本人承诺贷款实际用途与向贵行申请贷款提交 资料之用途一致且合法，即:不以任何形式挪用贷款或将贷款用于生产、经营、投资到国家及有关 监管部门明令禁止的产品和项目;不以贷款用于房地产开发、购买住房;不以贷款作为注册资本金 、注册验资和增资扩股，从事股本权益性投资;不将贷款用作股票、外汇、期货、期权及其他金融 衍生产品等投资;以及不将贷款投入到国家及有关监管部门明确规定的其他禁止用途。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("3、本人愿 意承担与贵行签署之相关合同文件中约定之贷款挪用罚息，且本人愿意承担一切违约责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("4、本 人承诺如出现上述违规行为，贵行有权采取措施提前收回贷款，且本人愿意承担一切违约责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("5 、本人承诺配合贵行所做贷后检查工作，包括但不限于对贷款用途的检查。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("6、本人对以上声明及 承诺的真实性负责并承担所有法律责任。 ")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt50"
  }, [_vm._v("注:1、本《贷款用途声明及承诺书》不得取代贷款用途 原始材料。")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd txin"
  }, [_vm._v("2、贷款用途可分为:购车、住房装修、出国留学、医疗、缴学费、结婚、购买耐用消 费品、企业生产经营、其他")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt50"
  }, [_vm._v("借款人、声明人、承诺人、授权人签章:")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt50"
  }, [_vm._v("华瑞银行签章:")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20 tc"
  }, [_vm._v("委托扣款授权书")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20"
  }, [_vm._v("特别提醒：在您确认签署本授权书之前，请您务必仔细阅读本授权书所有条款，尤其是以粗体及下划线标注的条款，一旦您在贷款人、服务方或其合作方的网站或其他与本贷款相关的软件客户端（以下简称“贷款服务平台”）点击接受本授权书，即意味您已充分理解本授权书所有条款的含义及相应的法律后果，不可撤销地同意您作为借款人作出本授权书的授权内容。")]), _vm._v(" "), _c('p', [_vm._v("授权人：借款人，简称“您”或“本人”；")]), _vm._v(" "), _c('p', [_vm._v("被授权人：贷款人【华瑞银行股份有限公司】（简称“华瑞银行”）、保险人【众安在线财产保险股份有限公司】（简称“众安保险”）、服务方【深圳众联商务有限公司】（简称“众联商务”）、绑定银行卡账户发放的银行（简称“发卡银行”）。")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("一、您保证提供给华瑞银行、众安保险、众联商务的银行卡账户资料（包括：卡号、姓名、证件号码、预留手机号码等）为您本人持有的真实、完整、准确、合法、有效的银行卡信息，并同意由众联商务或众安保险将以上信息送至发卡银行进行核验。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("二、您同意并授权华瑞银行根据您借款还款，您所购买基金、理财等产品的金额，通过支付清算机构以及发卡银行，从您提供的银行卡中扣款。您承诺前述委托扣款视同您本人作出，不得向支付清算机构以及发卡银行提出异议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("三、您同意并授权发卡银行或其他支付清算机构接受华瑞银行或众安保险委托，根据您在出借银行的借款金额，从您提供的银行卡账户中扣款用于还款。您承诺前述委托扣款视同您本人作出，不得向发卡银行及其他代理扣款的支付清算机构提出异议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("四、您同意并授权发卡银行或其他支付清算机构接受众联商务或其委托方委托，根据您在“华瑞银行·众安保险场景贷业务”（华瑞银行与众安保险合作项下的消费类贷款信用保险服务产品，以下简称“场景贷”）下签署的相关咨询服务协议中约定的咨询服务费及第三方杂费金额，从您提供的银行卡账户中扣款用于缴费。您承诺前述委托扣款视同您本人作出，不得向发卡银行及其他代理扣款的支付清算机构提出异议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("五、您同意并授权在您未按时履行还款义务导致保险事故发生，众安保险理赔后对您进行追偿时，由众安保险或其委托方合作的第三方支付公司或银行从您在本行开立的账户或您在本行绑定的他行账户中对您应付的贷款本息（含罚息）进行代扣。您承诺前述委托扣款视同您本人作出，不得向发卡银行及其他代理扣款的支付清算机构提出异议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("六、因您提供他人银行卡账户资料或虚假信息，或您提供的银行卡账户余额不足或被挂失、冻结、销户等原因而引起的一切损失和法律责任，由您自行承担，与华瑞银行、众安保险或众联商务无关。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("七、授权人在指定账户中必须留有足够余额，否则因账户余额不足或不可归责于被授权人或其委托方的任何事由，导致无法及时扣款或扣款错误、失败，责任由授权人自行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("八、如因第三方支付公司或银行限额、系统故障等原因导致扣款失败，委托扣款方将通知授权人，授权人需在2日内将该笔款项一次性主动划款至对应扣款人指定对公账户。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("九、因支付清算机构或发卡银行原因导致扣款错误或延迟，给您造成损失的，由过错方承担责任，委托扣款方将协助您向其追究相应责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("十、本授权书自授权人使用电子签章确认之日起生效，至授权人在“场景贷”业务下所有借款本金、利息及其他约定费用等全部偿还完毕时终止。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("客户确认：本人已认真阅读本协议，在完全理解本协议的情况下，同意本协议的全部内容，本人同意承担由此带来的一切法律后果。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 fwbd"
  }, [_vm._v("授权人：（电子签章）")]), _vm._v(" "), _c('p', [_vm._v("【系统填充】年【系统填充】月【系统填充】日")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f3514fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/loancontract.vue
// module id = 204
// module chunks = 0